<template>
  <div id="mi-pedido" >
    <!-- Informacion del pedido -->
    <div v-if="job_info">
      <!-- Modal para detalles del carton -->
      <div>
        <dialog ref="modal" class="w-9/10 h-9/10 rounded-lg">
          <div class="flex flex-col justify-center items-center h-full">
            <div class="flex flex-col justify-between items-center ">
              <h3 class="text-2xl font-600">
                Detalles del carton {{ carton_modal.no_carton }} de
                {{ carton_modal.total_cartons }}
              </h3>
              <p>
                <span class="text-gray-500"
                  >({{ carton_modal.qtythiscarton }} unidades)
                </span>
                <span>
                  {{ getJobPart(carton_modal.jobpart).ccpartdesc }}
                  
                </span>
              </p>
              <hr class="w-full border-1 border-gray-400 border-dashed"/>
              <div class="mt-8">
                <ol class="text-lg xl:text-xl">
                  <li
                    v-for="(evento, idx) in carton_modal.eventos"
                    :key="`evento-carton-${carton_modal.no_carton}-${evento.created}`"
                  >
                    <details class="text-left">
                      <summary :class="{'font-bold cursor-pointer text-gray-500':true, 'text-green-700': idx==carton_modal.eventos.length - 1}">
                        
                        <span class="">
                          {{ translateDate(new Date(evento.created)) }}
                        </span>
                        <span class="">({{ evento.status }})</span>
                      
                      </summary>
                      <div class="flex flex-col text-gray-700">
                        <p class="">
                          {{ evento.desc }}
                        </p>
                   
                      </div>
                    </details>
                    <div
                      v-show="idx < carton_modal.eventos.length - 1"
                      class="flex flex-row justify-center"
                    >
                      <div class="event-vertical-bar"></div>
                    </div>
                  </li>
                </ol>
              </div>

              <div class="flex flex-col justify-center items-center mt-8">
                <button
                  @click="closeModal"
                  class="btn-primary"
                  _class="p-2 mt-4 font-bold bg-blue-500 hover:bg-blue-600 text-white rounded-xl"
                >
                  Cerrar
                </button>
              </div>
            </div>
          
          </div>
        </dialog>
      </div>

      <div
        class="hidden p-4 bg-white flex flex-col content-center border-1 border-black"
      >
        <a href="#"
          ><img src="@/assets/tucan.png" style="width: 80px" alt=""
        /></a>
      </div>
      <div class="flex lg:flex-row flex-col flex-col-reverse">
        <div class="w-full lg:w-5/7 carton-container flex flex-col">
          <!-- Cartones -->
          
          <div v-if="Object.keys(cartons).length == 0">
            <div
              class="bg-white/50 backdrop-blur-xl p-16 mx-8 my-4 md:mx-24 lg:mt-9 lg:mb-4 rounded-lg border-1 border-black card-body"
            >
              <p class="text-center">
                <i class="mdi mdi-36px mdi-alert-circle"></i>
              </p>
              <p class="text-justify">
                <span
                  >La información acerca de los paquetes que conforman el pedido
                  aún no está disponible. Intente nuevamente más tarde o
                  contacte a soporte.
                  
                </span>
                <a
                class="text-md visited:text-purple-500 text-blue-500"
                  :href="`mailto:contacto@solotarjetas.com.mx?Subject=Necesito%20saber%20el%20estado%20de%20mi%20pedido:%20${orden}`"
                    >contacto@solotarjetas.com.mx</a
                  >
              </p>
            
            </div>
          </div>
          <h2 v-else class="py-4 text-xl uppercase text-center">Paquetes del pedido</h2>
          <div
            class=""
            v-for="carton in cartons_ordered_by_no_carton"
            :key="carton.no_carton"
          >
            <div class="card-carton-description lg:ml-16 lg:w-5/6">
              <div
                class="bg-white/50 backdrop-blur-xl px-8 py-2 mx-8 md:mx-24 my-2 h-auto lg:mt-2 lg:mb-2 rounded-lg border-1 border-black card-body"
              >
                <div
                  class="sm:w-full md:w-2/3 border-b-2 border-gray-400 border-dashed mb-4 text-left text-gray-600 font-500"
                >
                  Paquete
                  <span class="font-bold">{{ carton.no_carton }}</span> de
                  <span class="font-bold">{{ carton.total_cartons }}</span>
                </div>
                <div
                  class="flex flex-row justify-between justify-center items-center lg:w-2/3 lg:ml-18 text-lg xl:text-xl"
                >
                  <div class="flex flex-col justify-left align-left">
                    <p class="text-left">
                     
                      <span class="">
                         {{getJobPartDesc(carton.jobpart)}} - {{carton.jobpart}}
                        {{ getJobPart(carton.jobpart).ccpartdesc }} </span
                      >&nbsp;
                      <a
                        class="text-md visited:text-purple-500 text-blue-500"
                        href="#"
                        @click="openModal(carton)"
                        >Ver detalle</a
                      >
                    </p>
                  </div>
                  <div class="">
                    <span
                      class="rounded-full bg-blue-500 text-white w-12 h-12 flex items-center justify-center"
                    >
                      <i class="mdi mdi-24px mdi-package-variant"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-event-details lg:ml-16 lg:w-5/6">
              <div
                class="bg-white backdrop-blur-xl p-16 mx-8 md:mx-24 mt-2 rounded-lg border-1 border-black card-body"
              >
                <div class="flex flex-row justify-between">
                  <div v-if="carton.eventos && carton.eventos.length" class="flex flex-col justify-left align-left">
                    <p class="text-left">
                      <span class="text-xl text-green-700">
                        {{ carton.eventos.at(-1).status }}</span
                      >
                    </p>
                    <p class="text-left">
                      <span class="text-xl font-500">
                        {{ carton.eventos.at(-1).desc }}
                        <i class="mdi mdi-24px mdi-lightning-bolt"></i>
                      </span>
                    </p>
                    <p class="text-left mt-1">
                      <span class="text-md font-400 text-gray-500">
                        {{
                          translateDate(new Date(carton.eventos.at(-1).created))
                        }} </span
                      >&nbsp;&nbsp;
                      <button
                        _class="text-md visited:text-purple-500 text-blue-500 px-4 py-2 m-2 border-blue-500 border-2 rounded-lg hover:bg-blue-500 hover:text-white"
                        class="btn-primary"
                        href="#"
                        @click="openModal(carton)"
                      >
                        Ver eventos
                      </button>
                    </p>
                  </div>
                  <div v-else class="flex flex-col justify-left align-left">
                    <p class="text-left">
                      <span class="text-xl text-green-700">
                        Sin eventos
                        </span
                      >
                    </p>
                    <p class="text-left">
                      <span class="text-xl font-500">
                        No hay eventos registrados para este paquete
                        <i class="mdi mdi-24px mdi-lightning-bolt"></i>
                      </span>
                    </p>
                    <p class="text-left mt-1">
                      <span class="text-md font-400 text-gray-500">
                        </span
                      >&nbsp;&nbsp;
                      
                    </p>
                  </div>
                  <!-- <div class="">
                    <span class="rounded-full bg-blue-500 text-white w-16 h-16 flex items-center justify-center">
                      <i class="mdi mdi-36px mdi-package-variant"></i>
                    </span>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="w-full lg:w-2/7 lg:flex lg:h-screen"
          id="right-padding-element"
        >
          <div
            class="mt-8 mx-8 md:mx-24 md:mr-24 lg:mx-0 my-4 bg-white/80 backdrop-blur-xl p-4 rounded-lg border-1 border-black card-body"
          >
            <h3 class="text-2xl font-600">Detalles de la compra</h3>
            <small class="text-gray-600 text-left"
              >
              <table class="w-full tabla-detalles">
                <tr>
                  <td class="text-left text-gray-600">Fecha de compra:</td>
                  <td class="text-left">
                    <b>
                      {{ translateDate(new Date(`${job_info.ccdatesetup} ${job_info.cctimesetup} GMT-6`), false) }}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td class="text-left text-gray-600">No. de trabajo:</td>
                  <td class="text-left"><b>{{ job_info.ccmasterid }}</b></td>
                </tr>
                <tr v-if="job_info.dsforderid">
                  <td class="text-left text-gray-600">No. de orden:</td>
                  <td class="text-left"><b>{{ job_info.dsforderid }}</b></td>
                </tr>
                <tr>
                  <td class="text-left text-gray-600">No. de partes:</td>
                  <td class="text-left"><b>{{ job_info.jobparts.length }} parte(s)</b></td>
                </tr>
                <tr>
                  <td class="text-left text-gray-600">Paquetes registrados:</td>
                  <td class="text-left">
                    <b>{{ cartons_ordered_by_no_carton.length }} paquete(s)</b>
                  </td>
                </tr>
                <tr v-if="cantidades.mostrar">
                  <td class="text-left text-gray-600">
                    Piezas Entregadas:
                  </td>
                  <td class="text-left">
                    <b
                      >{{ formatPiezas(cantidades.entregadas) }}/{{
                        formatPiezas(cantidades.ordenada)
                      }}&nbsp;piezas
                    </b>
                  </td>
                </tr>
              </table>
            </small>
            <hr />
            <div class="text-center flex flex-col space-x-2">
             
              <table>
                <tr>
                  <td class="text-left text-gray-600">Trabajo</td>
                  <td class="text-right">{{ formatCurrencyMXN(JobValue) }}</td>
                </tr>
                <tr v-if="Extras">
                  <td class="text-left text-gray-600">Extras</td>
                  <td class="text-right">{{ formatCurrencyMXN(Extras) }}</td>
                </tr>
                <tr v-if="CostoEnvio">
                  <td class="text-left text-gray-600">Envío</td>
                  <td class="text-right">
                    {{ formatCurrencyMXN(CostoEnvio) }}
                  </td>
                </tr>
                <tr v-if="Descuentos">
                  <td class="text-left text-green-700 font-bold">Descuentos</td>
                  <td class="text-right font-bold text-green-700">
                    -{{ formatCurrencyMXN(Descuentos * -1) }}
                  </td>
                </tr>
              </table>
              <hr />
              <table>
                <tr>
                  <td class="text-left text-gray-600">Subtotal</td>
                  <td class="text-right">{{ formatCurrencyMXN(Subtotal) }}</td>
                </tr>
                <tr>
                  <td class="text-left text-gray-600">Impuestos( IVA 16% )</td>
                  <td class="text-right">{{ formatCurrencyMXN(Impuestos) }}</td>
                </tr>
                <tr>
                  <td class="text-left text-gray-600 font-bold">Total</td>
                  <td class="text-right font-bold">
                    {{ formatCurrencyMXN(Subtotal + Impuestos) }}
                  </td>
                </tr>
                
              </table>
              
              <hr class="w-full">
                <div class="my-4">
                <h3 v-if="Object.keys(number_guides).length" class="uppercase font-bold">Números de guía</h3>
                <table v-for="(guias, paqueteria) in number_guides" class="tabla" :key="paqueteria+'-'+guias">
                  <thead>
                    <tr>
                      <th class="text-right text-gray-600">Paquetería</th>
                      <th class="text-left text-gray-600">Número de guía</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="guia in guias" :key="guia">
                      <td><b>{{paqueteria}}</b></td>
                      <td>{{guia}}
                        <button @click="copyToClipboard(guia)" class="mdi mdi-content-copy text-gray-600 hover:text-black"></button>
                      </td>
                    </tr>
                  </tbody>
              </table>
              </div>
              
             
              <div class="flex flex-col mt-2">
                <button
                  @click="clearJob"
                  class="btn-primary"
                  _class="uppercase p-2 mt-4 font-bold bg-blue-500 hover:bg-blue-600 text-white rounded-xl"
                >
                  Consultar otra orden
                </button>
                <a
                  href="https://emprende.soltarimpresores.com/facturas"
                  target="_blank"
                  class="btn-primary"
                  _class="uppercase p-2 mt-4 font-bold bg-blue-500 hover:bg-blue-600 text-white rounded-xl"
                >
                  Solicitar factura
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Sin numero de orden  y orden no encontrada-->
    <div
      v-if="(job_not_found || !job_info) && !cargando"
      class="flex items-center justify-center h-screen"
    >
      <div class="p-4 text-center">
        <div v-if="!job_info">
          <p>
            <i class="mdi mdi-alert-circle mdi-36px"></i>
            <span class="text-2xl font-bold"
              >Introduce un número de orden/trabajo.</span
            >
          </p>
          <p>
            Por favor, verifique el número de orden/trabajo y haga clic en el
            botón VERIFICAR.
          </p>
        </div>
        <form
          @submit="
            (e) => {
              e.preventDefault();
              redirect2job(user_orden);
            }
          "
        >
          <input
            class="text-center font-bold text-xl invalid:border-red-500"
            type="text"
            @click="
              (e) => {
                user_orden = '';
              }
            "
            v-model="user_orden"
            required
            placeholder="número de orden/trabajo"
            @input="
              (e) => {
                e.target.value = e.target.value.toUpperCase();
                e.target.checkValidity();
              }
            "
            pattern="([D]{0,1}[0-9]{6,7})"
            title="Formato de número de orden/trabajo: D1234567 o 1234567"
          />
          <button
            type="submit"
            placeholder="Introduce el número de orden/trabajo"
            class="btn-primary"
            _class="m-8 p-4 rounded-xl uppercase bg-blue-700 text-white"
          >
            VERIFICAR
          </button>
        </form>
        <p>
          Si el problema persiste, contacte con el servicio de soporte enviando
          un email a
          <a
          class="text-md visited:text-purple-500 text-blue-500"
            :href="`mailto:contacto@solotarjetas.com.mx?Subject=Necesito%20saber%20el%20estado%20de%20mi%20pedido:%20${orden}`"
          >
            contacto@solotarjetas.com.mx</a
          >
        </p>
      </div>
    </div>
    <!-- Cargando -->
    <div v-if="cargando" class="flex items-center justify-center h-screen">
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<style scoped src="windi.css"></style>
<style scoped>
.event-vertical-bar{
  width: 5px;
  height: 50px;
  background-color: green;
}
.btn-primary {
  margin: 0.2rem;
  padding: 5px 17px;
  border-radius: 20px;
  background: linear-gradient(to right, #1aa9e6, #008fcc);
  color: white !important;
  font-size: 15px;
  font-weight: 900;
  text-transform: uppercase;
  min-width: fit-content;
}
.btn-primary:hover {
  background: linear-gradient(
    to right,
    #008fcc,
    #1aa9e6
  );
}
dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
}
table.tabla-detalles tr td {
  padding: 2px 8px 2px 0;
  border-bottom: none;
}
table.tabla > tbody > tr > td {
  color: rgba(0, 0, 0, 0.75);
  text-align: left;
  width: 2em;
}
table.tabla > thead > tr > th {
  color: rgba(0, 0, 0, 0.75);
  text-align: left;
  width: auto;
}
table.tabla > tbody > tr {
  border-bottom: solid gray 0.05em;
}

table.tabla > thead {
  border-bottom: solid gray 0.2em;
}
div.card {
  background-color: #f8f8f8;
  overflow: scroll;
  height: 24em;
}
#mi-pedido {
  background-color: #ffffff !important;
  background: #ffffff !important;
}
summary::marker {
  font-family: monospace;
  color: green;
  font-weight: bold;
}

  
</style>

<script>
import firebase from "firebase/app";
import "firebase/functions";
import Helpers from "@/helpers.js";

//import almacenes from "@/tracker/recursos/almacenes_domicilios.json";

const API_JOBINFO = "https://emprende.soltarimpresores.com/api/jobinfo/{orden}";
const API_ICLOCID = "https://emprende.soltarimpresores.com/api/iclocid";
const API_JOB_PRODUCT =
  "https://n8n.soltarimpresores.com/webhook/job/track/job-product?job={job}";

export default {
  name: "Mi Pedido",
  props: {
    orden: { type: String },
  },
  created() {
    if (this.orden && this.orden.length) this.getJobInfo(this.orden);
    else {
      sessionStorage.clear();
    }
  },
  data() {
    let functions = firebase.functions();

    return {
      carton_modal: {},
      functions: functions,
      job_not_found: false,
      almacenes: {},
      iclocids: [],
      sin_info: false,
      suscrito: false,
      db: firebase.firestore(),
      cargando: false,
      activando: false,
      job_info: undefined,
      user_orden: this.orden,
      product_description: "",
      cartons: {},
    };
  },
  methods: {
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(text)
          .then(() => alert("¡Copiado al portapapeles!"));
      } else {
        alert("No se pudo copiar al portapapeles.");
      }
    },
    getToken: Helpers.getToken,
    closeModal() {
      this.$refs.modal.close();
    },
    openModal(carton) {
      this.carton_modal = carton;
      this.$refs.modal.showModal();
    },
    cleanJob() {
      this.job_info = undefined;
    },
    redirect2job(orden) {
      if (orden && orden.length) {
        window.location.href = `${window.location.origin}/trabajo?orden=${orden}`;
      }
    },
    formatCurrencyMXN(value) {
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(value);
    },
    formatPiezas(value) {
      return new Intl.NumberFormat("es-MX").format(value);
    },
    clearJob() {
      sessionStorage.removeItem("job_info");
      sessionStorage.removeItem("cartons");
      sessionStorage.removeItem("almacenes");
      sessionStorage.removeItem("orden");
      sessionStorage.removeItem("product_description");
      this.job_info = null;
      this.cartons = {};
      this.almacenes = {};
      this.iclocids = [];
      this.job_not_found = false;
      this.product_description = "";
    },
    getJobInfo(orden) {
      if (!orden) {
        return {};
      }
      orden = orden.trim().toUpperCase();

      let session_orden = sessionStorage.getItem("orden");

      if (session_orden && session_orden != this.orden) {
        this.clearJob();
      }
      if (sessionStorage.getItem("job_info")) {
        this.job_info = JSON.parse(sessionStorage.getItem("job_info"));
        this.cartons = JSON.parse(sessionStorage.getItem("cartons"));
        this.product_description =
          sessionStorage.getItem("product_description") || "";
        if (this.faltaDescParte() && !this.product_description)
          this.getProductDescription();
        return;
      }
      this.cargando = true;
      fetch(new Request(API_JOBINFO.replace("{orden}", orden)))
        .then((res) => {
          if (res.ok)
            return res.json().then((info) => {
              this.job_info = info;
              sessionStorage.setItem("job_info", JSON.stringify(info));
              sessionStorage.setItem("orden", this.orden);
              if (this.faltaDescParte()) this.getProductDescription();
              // // Solicitar permiso para notificaciones y suscribir el FCM token al topic.
              // this.getToken().then((currentToken) => {
              //   this.suscribe(currentToken, info.ccmasterid).then(() => {
              //     this.suscrito = true;
              //     console.log(currentToken, "suscrito");
              //   });
              // });

              this.db
                .collection("cartons")
                .where("ccmasterid", "==", this.job_info.ccmasterid)
                .orderBy("no_carton", "asc")
                .get()
                .then((snap) => {
                  this.sin_info = snap.docs.length == 0;
                  snap.docs.forEach((doc) => {
                    let carton = doc.data();
                    if ("eventos" in carton) {
                      carton.eventos.forEach((ev) => {
                        ev.created = ev.created.toDate();
                      });
                    }
                    Object.keys(carton).forEach((key) => {
                      if (
                        carton[key] &&
                        typeof carton[key] == "object" &&
                        carton[key]["toDate"]
                      )
                        carton[key] = carton[key].toDate();
                    });
                    this.cartons[doc.id] = carton;
                    if (
                      carton.iclocid &&
                      this.iclocids.indexOf(carton.iclocid) < 0
                    )
                      this.iclocids.push(carton.iclocid);
                  });
                  sessionStorage.setItem(
                    "cartons",
                    JSON.stringify(this.cartons)
                  );
                  this.getIclocids();
                  this.$forceUpdate();
                });
            });
          else if (res.status == 404) {
            this.job_info = null;
            this.job_not_found = true;
          }
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    faltaDescParte() {
      let job = this.job_info || {};
      return !job.dsforderid;
    },
    getProductDescription() {
      let ccmasterid = (this.job_info || {}).ccmasterid;
      if (!ccmasterid) return;
      let req = new Request(API_JOB_PRODUCT.replace("{job}", ccmasterid));
      fetch(req)
        .then((res) => {
          if (res.ok) return res.json();
          return [];
        })
        .then((productos) => {
          let descripciones = (Array.isArray(productos) ? productos : [])
            .map((p) => p.description)
            .filter((d) => d && d.trim());
          this.product_description = [...new Set(descripciones)].join(", ");
          sessionStorage.setItem(
            "product_description",
            this.product_description
          );
        })
        .catch(() => {
          this.product_description = "";
        });
    },
    getJobPartDesc(ccjobpart){
      let jobparts = this.job_info.jobparts;
      if (!ccjobpart || !jobparts)
        return this.product_description || "Sin descripción disponible.";
      let jobpart = jobparts.find((p)=>p.ccjobpart===ccjobpart);
      if (jobpart && jobpart.ccpartdesc) {
        return jobpart.ccpartdesc;
      }
      return this.product_description || "Sin descripción disponible.";
    },
    getJobPart(ccjobpart) {
      if (!ccjobpart || !this.job_info.jobparts)
        return {
          ccpartdesc: this.product_description || "Sin descripción disponible.",
        };
      let jobpart = this.job_info.jobparts.find(
        (part) => part.ccjobpart === ccjobpart
      );
      if (!jobpart)
        return {
          ccpartdesc: this.product_description || "Sin descripción disponible.",
        };
      if (!jobpart.ccpartdesc)
        jobpart = {
          ...jobpart,
          ccpartdesc:
            this.product_description || "Sin descripción disponible.",
        };
      return jobpart;
    },
    translateDate(date, showTime = true) {
      let day = date.getDay();
      switch (day) {
        case 0:
          day = "Dom";
          break;
        case 1:
          day = "Lun";
          break;
        case 2:
          day = "Mar";
          break;
        case 3:
          day = "Mié";
          break;
        case 4:
          day = "Jue";
          break;
        case 5:
          day = "Vie";
          break;
        case 6:
          day = "Sáb";
          break;
      }
      let month = date.getMonth();
      switch (month) {
        case 0:
          month = "Ene";
          break;
        case 1:
          month = "Feb";
          break;
        case 2:
          month = "Mar";
          break;
        case 3:
          month = "Abr";
          break;
        case 4:
          month = "May";
          break;
        case 5:
          month = "Jun";
          break;
        case 6:
          month = "Jul";
          break;
        case 7:
          month = "Ago";
          break;
        case 8:
          month = "Sep";
          break;
        case 9:
          month = "Oct";  
          break;
        case 10:
          month = "Nov";
          break;
        case 11:
          month = "Dic";
          break;
      }
      if (showTime)
      return `${day} ${date.getDate()} de ${month} ${date.getFullYear()} a las ${date.toLocaleTimeString()}`;
      return `${day} ${date.getDate()} de ${month} ${date.getFullYear()}`;
    },
    getIclocids() {
      if (sessionStorage.getItem("almacenes")) {
        this.almacenes = JSON.parse(sessionStorage.getItem("almacenes"));

        return;
      }
      let req = new Request(API_ICLOCID, {
        method: "POST",
        headers: new Headers({ "Content-Type": "application/json" }),
        body: JSON.stringify({ iclocids: this.iclocids }),
      });
      this.cargando = true;
      fetch(req)
        .then((res) => {
          if (res.ok) return res.json();
        })
        .then((iclocids) => {
          this.almacenes = iclocids;
          sessionStorage.setItem("almacenes", JSON.stringify(iclocids));
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    copiar(text) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(text)
          .then(alert("¡Copiado al portapapeles!"));
      }
    },
    suscribe(token, topic) {
      let data = {
        token: token,
        topic: topic,
      };
      return this.functions.httpsCallable("subscribeToken")(data);
    },
    unsubscribe(token, topic) {
      let data = {
        token: token,
        topic: topic,
      };
      return this.functions.httpsCallable("unsubscribeToken")(data);
    },
    suscribeButton() {
      this.activando = true;
      this.getToken().then((currentToken) => {
        if (!this.suscrito) {
          this.suscribe(currentToken, this.job_info.ccmasterid)
            .then(() => {
              this.suscrito = true;
              console.log(currentToken, "suscrito");
            })
            .finally(() => {
              this.activando = false;
            });
        } else {
          this.unsubscribe(currentToken, this.job_info.ccmasterid)
            .then(() => {
              this.suscrito = false;
              console.log(currentToken, "unsuscrito");
              this.$forceUpdate();
            })
            .finally(() => {
              this.activando = false;
            });
        }
      });
    },

    cuentaCartons(cartons) {
      return Object.keys(cartons).length;
    },
    formatNumero: new Intl.NumberFormat("en-US").format,
  },

  computed: {
    number_guides() {
      let guias =  {};
      Object.values(this.cartons).forEach((carton) => {
        if (carton.paqueteria_numero_rastreo) {
          if (guias[carton.paqueteria_name] && guias[carton.paqueteria_name].indexOf(carton.paqueteria_numero_rastreo) < 0) {
            guias[carton.paqueteria_name].push(carton.paqueteria_numero_rastreo);
          } else {
            guias[carton.paqueteria_name] = [carton.paqueteria_numero_rastreo];
          }
        }
      });
      return guias;
    },
    JobValue() {
      return this.job_info.jobvalue * 1;
    },
    cantidades() {
      let job = this.job_info || {};
      let ordenada = Number(job.quantityordered) || 0;
      let entregadas = Number(job.qtyshipped) || 0;
      return {
        ordenada,
        entregadas,
        mostrar: ordenada > 0 || entregadas > 0,
      };
    },
    Descuentos() {
      if (!("extras" in this.job_info && "extras" in this.job_info.extras))
        return 0;
      let extraInvoices = this.job_info.extras.extras;
      return extraInvoices
        .filter((invoice) => {
          return invoice.price * 1 < 0;
        })
        .map((invoice) => invoice.price * 1)
        .reduce((a, b) => a + b, 0);
    },
    CostoEnvio() {
      if (!("extras" in this.job_info && "extras" in this.job_info.extras))
        return 0;
      let extraInvoices = this.job_info.extras.extras;
      console.table(extraInvoices);
      return extraInvoices
        .filter((invoice) => {
          return (
            invoice.price * 1 > 0 &&
            invoice.description.toUpperCase().indexOf("FLETE") > -1
          );
        })
        .map((invoice) => invoice.price * 1)
        .reduce((a, b) => a + b, 0);
    },
    Extras() {
      if (!("extras" in this.job_info && "extras" in this.job_info.extras))
        return 0;
      let extraInvoices = this.job_info.extras.extras;
      return extraInvoices
        .filter((invoice) => {
          return (
            invoice.price * 1 > 0 &&
            invoice.description.toUpperCase().indexOf("FLETE") == -1
          );
        })
        .map((invoice) => invoice.price * 1)
        .reduce((a, b) => a + b, 0);
    },
    Impuestos() {
      if (!("extras" in this.job_info && "impuestos" in this.job_info.extras))
        return 0;
      let extraInvoices = this.job_info.extras.impuestos;
      return extraInvoices
        .map((invoice) => invoice.amount * 1)
        .reduce((a, b) => a + b, 0);
    },
    Subtotal() {
      return this.JobValue + this.Extras + this.CostoEnvio + this.Descuentos;
    },

    cartones() {
      let job = this.job;

      return Object.values(this.cartons)
        .sort((a, b) => {
          return a.no_carton * 1 - b.no_carton * 1;
        })
        .map((carton) => {
          return { part: job.jobparts[carton.jobpart], ...carton };
        });
    },
    entregas_disponibles() {
      let entregas = [],
        cartons = this.cartons;

      Object.values(cartons)
        .filter((carton) => carton.status === "Recibido en tienda")
        .forEach((carton) => {
          if (carton.iclocid) {
            entregas.push({
              sucursal: this.almacenes[carton.iclocid],
              ...carton,
            });
          }
        });
      return entregas;
    },
    entregas() {
      let entregas = {},
        cartons = this.cartons;

      Object.keys(cartons).forEach((cartonId) => {
        let carton = cartons[cartonId];
        if (carton.entregado) {
          entregas[cartonId] = {
            sucursal: this.almacenes[carton.iclocid],
            ...carton,
          };
        }
      });
      return Object.values(entregas);
    },
    total_partes() {
      return Object.keys(this.job.jobparts).length;
    },
    total_cartons() {
      let total_cartones = Object.values(this.cartons).map(
        (carton) => carton.total_cartons
      );
      return Math.max(...total_cartones, 0);
    },
    cartons_length() {
      let job = this.job;
      return (
        Object.values(job.jobparts)
          .map((part) => part.cartons_length)
          .reduce((a, b) => {
            a + b;
          }) || 0
      );
    },
    cartons_ordered_by_no_carton() {
      let cartons = { ...this.cartons };
      return Object.values(cartons).sort((a, b) => {
        return a.no_carton * 1 - b.no_carton * 1;
      });
    },
    lencartons() {
      return Object.keys(this.cartons).length;
    },
    envios() {
      let guias = {},
        sin_guia = [],
        cartons = this.cartons,
        carton_values = Object.values(cartons);
      carton_values.forEach((carton) => {
        if (carton["paqueteria_numero_rastreo"])
          if (guias[carton["paqueteria_numero_rastreo"]])
            guias[carton["paqueteria_numero_rastreo"]]["cartons"].push(carton);
          else
            guias[carton["paqueteria_numero_rastreo"]] = {
              no_guia: carton["paqueteria_numero_rastreo"],
              paqueteria: carton.paqueteria_name,
              updated: carton.updated,
              cartons: [carton],
            };
        else sin_guia.push(carton);
      });
      // if (sin_guia.length) guias["Sin asignar"] = { cartons: sin_guia };
      return Object.values(guias);
    },
  },
};
</script>
